// FAQ content for homepage / best-vpns (rendered as accordion + FAQ JSON-LD)
export const FAQS = [
  {
    q: "What is the best VPN in 2026?",
    a: "NordVPN is our top-rated VPN for 2026. It leads on speed, streaming support, server coverage, and security. Its independently-audited no-log policy means your browsing genuinely stays private. Plans start from $3.09/month on a 2-year plan with a 30-day money-back guarantee.",
    cta: true,
  },
  {
    q: "Are VPNs legal?",
    a: "Yes, VPNs are legal in most countries. Using a VPN is a standard privacy practice and is legal in the US, UK, EU, Canada, and Australia. A small number of countries restrict VPN use (China, Russia, UAE, North Korea) — check local laws if you're travelling.",
  },
  {
    q: "Does a VPN slow down your internet?",
    a: "A quality VPN has minimal impact on speed. NordVPN retained 95%+ of our base connection speed in testing. Slower VPNs may reduce speeds by 20-40%. If you're experiencing slowdowns, switch to a closer server or use WireGuard protocol (NordLynx on NordVPN).",
  },
  {
    q: "Can a VPN be hacked?",
    a: "A reputable VPN with strong encryption (AES-256) is extremely difficult to hack. The bigger risks are weak passwords, malware on your device, or using an untrustworthy VPN provider. Stick to audited, no-log VPNs like NordVPN and Surfshark.",
  },
  {
    q: "Which VPN is best for streaming Netflix?",
    a: "NordVPN is the best VPN for Netflix in 2026. It reliably unblocks US, UK, and regional Netflix libraries from anywhere in the world. Surfshark is a close second. See our full guide to the best VPN for streaming.",
    link: { label: "Best VPN for Netflix", to: "/best-vpn-for/netflix" },
  },
  {
    q: "How much does a VPN cost?",
    a: "VPN pricing ranges from $1.99/month (PureVPN on a long-term deal) to $11.99/month for a monthly plan. Most users get the best value on 1-2 year plans. NordVPN costs $3.09/month on a 2-year plan and includes a 30-day money-back guarantee.",
  },
  {
    q: "Do free VPNs work?",
    a: "Free VPNs come with serious trade-offs: data caps, slower speeds, fewer servers, and — most concerning — many monetise by logging and selling your browsing data. AdGuard VPN offers a genuine free tier (3GB/month) from a reputable company, but for real privacy and streaming, a paid VPN like NordVPN at $3.09/month is the safer choice.",
  },
];
